import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { pauseParkingService } from '../../api/parking-service.ts';

export default function usePauseParkingService(): UseMutationResult<
  Awaited<ReturnType<typeof pauseParkingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => pauseParkingService(serviceId),
  });
}
